export default class KeyBoardListnerHelper {
  static getkey(event: any): string {
    return event.key;
  }
}
